import LandingPage from "./landing-page";

const landingPageRoutes = [{ path: "", element: <LandingPage /> }];

export default landingPageRoutes;
